<template>
  <div id="score_margin" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-2" v-if="season_dropdown.data != undefined">
        <season-select v-model="seasons_selected" :options="season_dropdown"></season-select>
      </div>

      <div class="col-md-2" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>

      <div class="col-md-1" v-if="team_dropdown.data != undefined">
        <team-select v-model="team_selected" :options="team_dropdown" :preselectFirst="true" :allowEmpty="false"></team-select>
      </div>

      <div class="col-md-2">
        <label class="typo__label">Period</label>
        <multiselect
          v-model="period_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          placeholder=""
          :options="period_dropdown"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>
    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Show Graph</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div>
      <svg width="960" height="600"></svg>
    </div>

  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import TeamSelect from './mixins/TeamSelect.vue'
import { season, seasonType } from './mixins/dropdowns'
const d3 = require('d3')

export default {
  name: 'ScoreMargin',
  components: {
    Multiselect,
    SeasonTypeSelect,
    SeasonSelect,
    TeamSelect
  },
  mixins: [SeasonTypeSelect, SeasonSelect, TeamSelect, GetDropdownOptions, season, seasonType],
  data () {
    return {
      loading: false,
      season_type_dropdown: {},
      season_type_selected: undefined,
      season_dropdown: {},
      seasons_selected: [],
      period_dropdown: [
        {'id': 'All', 'text': 'All'},
        {'id': '1', 'text': '1'},
        {'id': '2', 'text': '2'},
        {'id': '3', 'text': '3'},
        {'id': '4', 'text': '4'},
        {'id': 'SecondHalf', 'text': 'Second Half'}
      ],
      period_selected: undefined,
      season_selected_string: '',
      team_dropdown: {},
      team_selected: undefined,
      show_error_message: false,
      api_endpoint: 'get-score-margin-breakdown/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      d3.selectAll('svg > *').remove()
      this.results = []
      this.seasons_selected = []
      this.season_selected_string = ''
      this.$router.push({name: 'score_margin', params: {league: this.$parent.league}})
    },
    setPeriodDropdown (response) {
      if (!this.period_selected) {
        this.period_selected = this.period_dropdown[0]
      }

      if (this.$route.query.Period) {
        this.period_dropdown.forEach((period) => {
          if (period.id === this.$route.query.Period) {
            this.period_selected = period
          }
        })
      }
    },
    checkIfStatsShouldBeLoaded (response) {
      if (this.seasons_selected.length > 0 && this.season_type_selected && this.team_selected) {
        this.getStats()
      }
    },
    loadData () {
      var params = {}
      params[this.$typeParam] = 'ScoreMargin'
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setTeamDropdown, this.setPeriodDropdown, this.checkIfStatsShouldBeLoaded])
    },
    updateData () {
      if (this.$route.query.Season && this.$route.query.SeasonType) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changeStats () {
      var params = {}

      this.season_selected_string = this.getSeasonsSelectedString()
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id
      params[this.$teamIdParam] = this.team_selected.id
      if (this.period_selected) {
        params[this.$periodParam] = this.period_selected.id
      }

      this.$router.push({name: 'score_margin', query: params})
    },
    getStats () {
      this.show_error_message = false
      var params = this.$route.query
      d3.selectAll('svg > *').remove()
      if (params.Season && params.SeasonType && params.TeamId) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.results = response.data.margins
              this.addChart()
              this.loading = false
            } else {
              this.show_error_message = true
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    },
    addChart () {
      d3.selectAll('svg > *').remove()
      var margin = {top: 20, right: 20, bottom: 30, left: 60}
      var width = 960 - margin.left - margin.right
      var height = 500 - margin.top - margin.bottom

      var tooltip = d3.select('body').append('div').attr('class', 'margin-tooltip')

      var x = d3.scaleBand().rangeRound([0, width], 0.1).paddingInner(0.1)
      var y = d3.scaleLinear().range([height, 0])
      var xAxis = d3.axisBottom().scale(x)
      var yAxis = d3.axisLeft().scale(y).ticks(10, '%')

      var svg = d3.select('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .append('g')
        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

      x.domain(this.results.map(function (d) { return d.margin }))
      y.domain([0, d3.max(this.results, function (d) { return d.frequency })])

      svg.append('g')
        .attr('class', 'x axis')
        .attr('transform', 'translate(0,' + height + ')')
        .call(xAxis)

      svg.append('g')
        .attr('class', 'y axis')
        .call(yAxis)

      // y-axis label
      svg.append('text')
        .attr('transform', `rotate(270) translate(${-width / 4} ${-margin.left})`)
        .attr('dy', 12) // adjust distance from the left edge
        .attr('class', 'axis-label')
        .attr('text-anchor', 'middle')
        .text('Percentage of Possessions')

      svg.selectAll('.bar')
        .data(this.results)
        .enter().append('rect')
        .attr('x', function (d) { return x(d.margin) })
        .attr('width', x.bandwidth())
        .attr('y', function (d) { return y(d.frequency) })
        .attr('height', function (d) { return height - y(d.frequency) })
        .attr('class', function (d) {
          if (d.margin === '0') {
            return 'margin-tie'
          } else if (d.margin > 0) {
            return 'margin-winning'
          } else if (d.margin === '20+') {
            return 'margin-winning'
          } else {
            return 'margin-losing'
          }
        })
        .on('mousemove', function (d) {
          tooltip
            .style('left', d3.event.pageX - 50 + 'px')
            .style('top', d3.event.pageY - 70 + 'px')
            .style('display', 'inline-block')
            .html('Margin: ' + (d.margin) + '<br>' + 'Frequency: ' + (Math.round(d.frequency * 10000) / 100) + '%')
        })
        .on('mouseout', function (d) { tooltip.style('display', 'none') })
    }
  }
}
</script>

<style>
svg rect.margin-tie {
  fill: black;
}

svg rect.margin-losing {
  fill: red;
}

svg rect.margin-winning {
  fill: green;
}

.margin-tooltip {
  position: absolute;
  display: none;
  height: auto;
  background: none repeat scroll 0 0 #ffffff;
  border: 1px solid black;
  text-anchor: middle;
  padding: 5px;
}

.axis {
  font: 10px sans-serif;
}

.axis path,
.axis line {
  fill: none;
  stroke: #000;
  shape-rendering: crispEdges;
  stroke-width: .5;
}

.x.axis path {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ScoreMargin.vue